/**
 * JoCell Regions Data — Jordan governorates & delivery rules
 * Single source of truth. Used by: header picker, PDP delivery card, cart, shipping estimator.
 * Edit via Theme Settings → Countries & Delivery
 */
window.__JOCELL_REGIONS = {
  countries: {
    jo: {
      name_ar: "الأردن", name_en: "Jordan", flag: "🇯🇴", code: "JO", currency: "JOD",
      governorates: {
        amman:   { name_ar:"عمّان",    name_en:"Amman",    zone:"capital", fee:2,  days_min:0, days_max:1, same_day:true, cod:true },
        zarqa:   { name_ar:"الزرقاء",  name_en:"Zarqa",    zone:"near",    fee:2.5,days_min:1, days_max:2, same_day:false,cod:true },
        irbid:   { name_ar:"إربد",     name_en:"Irbid",    zone:"near",    fee:3,  days_min:1, days_max:2, same_day:false,cod:true },
        balqa:   { name_ar:"البلقاء",  name_en:"Balqa",    zone:"near",    fee:2.5,days_min:1, days_max:2, same_day:false,cod:true },
        madaba:  { name_ar:"مادبا",    name_en:"Madaba",   zone:"near",    fee:2.5,days_min:1, days_max:2, same_day:false,cod:true },
        mafraq:  { name_ar:"المفرق",   name_en:"Mafraq",   zone:"mid",     fee:3.5,days_min:2, days_max:3, same_day:false,cod:true },
        jerash:  { name_ar:"جرش",      name_en:"Jerash",   zone:"mid",     fee:3,  days_min:1, days_max:2, same_day:false,cod:true },
        ajloun:  { name_ar:"عجلون",    name_en:"Ajloun",   zone:"mid",     fee:3,  days_min:1, days_max:2, same_day:false,cod:true },
        karak:   { name_ar:"الكرك",    name_en:"Karak",    zone:"mid",     fee:3.5,days_min:2, days_max:3, same_day:false,cod:true },
        maan:    { name_ar:"معان",     name_en:"Ma'an",    zone:"far",     fee:4,  days_min:2, days_max:4, same_day:false,cod:true },
        tafilah: { name_ar:"الطفيلة",  name_en:"Tafilah",  zone:"far",     fee:4,  days_min:2, days_max:3, same_day:false,cod:true },
        aqaba:   { name_ar:"العقبة",   name_en:"Aqaba",    zone:"far",     fee:4,  days_min:2, days_max:4, same_day:false,cod:true }
      }
    }
  },
  // Helper methods
  getCountry: function(code) { return this.countries[code] || null; },
  getGov: function(country, gov) {
    var c = this.countries[country];
    return c ? (c.governorates[gov] || null) : null;
  },
  getName: function(country, gov, lang) {
    var g = this.getGov(country, gov);
    return g ? g['name_' + lang] : '';
  },
  getCountryName: function(code, lang) {
    var c = this.countries[code];
    return c ? c['name_' + lang] : '';
  }
};
